export const company = state => state.company.company;
export const companyData = state => state.company.companyData;
export const ownerData = state => state.company.ownerData;
